import { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import DatePicker from "react-datepicker";
import { FixColumn } from "../../../../utils/dataTable";
import { MultiSelect } from "primereact/multiselect";
import RNX_WoWHeatmapSingleWeekSummaryModal from "../../RNX_WoWHeatmapSingleWeekSummaryModal";

const RNXWOWPickup = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const [selectedMarketSegment, setSelectedMarketSegment] = useState([]);
    const [selectedTempMarketSegment, setSelectedTempMarketSegment] = useState([]);
    const [marketSegmentData, setMarketSegmentData] = useState([]);
    const multiselectRef = useRef(null);

    const yearsArr = [
        ...commonService.getPastYearForDropDown(10),
        ...commonService.getFutureYearForDropDown(10),
        new Date().getFullYear(),
    ]?.sort(function (a, b) { return a - b; });

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const [widgetModal, setWidgetModal] = useState(false);
    const [SelectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const [FinalData, setFinalData] = useState([]);

    const widgetDetailRef = useRef();
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [dataLoading, setDataLoading] = useState(false);
    useEffect(() => {
        if (api === 0) {
            const monthData = [1, 2, 3, 4].map(m => ({
                "MonthName": "Jan",
                "WeekNo": m,
                "WeekName": "",
                "channel": "",
                "BW0_RMS": 0,
                "BW1_RMS": 0,
                "BW2TO7_RMS": 0,
                "BW8TO15_RMS": 0,
                "BW16TO30_RMS": 0,
                "BW31TO60_RMS": 0,
                "BW61TO90_RMS": 0,
                "BW91TOUP_RMS": 0,
                "BW0_REV": 0,
                "BW1_REV": 0,
                "BW2TO7_REV": 0,
                "BW8TO15_REV": 0,
                "BW16TO30_REV": 0,
                "BW31TO60_REV": 0,
                "BW61TO90_REV": 0,
                "BW91TOUP_REV": 0,
                "BW0_ADR": 0,
                "BW1_ADR": 0,
                "BW2TO7_ADR": 0,
                "BW8TO15_ADR": 0,
                "BW16TO30_ADR": 0,
                "BW31TO60_ADR": 0,
                "BW61TO90_ADR": 0,
                "BW91TOUP_ADR": 0,
                "TOTAL_ADR": 0,
                "TOTAL_RMS": 0,
                "TOTAL_REV": 0,

                "BW0_RMS_STLY": 0,
                "BW1_RMS_STLY": 0,
                "BW2TO7_RMS_STLY": 0,
                "BW8TO15_RMS_STLY": 0,
                "BW16TO30_RMS_STLY": 0,
                "BW31TO60_RMS_STLY": 0,
                "BW61TO90_RMS_STLY": 0,
                "BW91TOUP_RMS_STLY": 0,
                "BW0_REV_STLY": 0,
                "BW1_REV_STLY": 0,
                "BW2TO7_REV_STLY": 0,
                "BW8TO15_REV_STLY": 0,
                "BW16TO30_REV_STLY": 0,
                "BW31TO60_REV_STLY": 0,
                "BW61TO90_REV_STLY": 0,
                "BW91TOUP_REV_STLY": 0,
                "BW0_ADR_STLY": 0,
                "BW1_ADR_STLY": 0,
                "BW2TO7_ADR_STLY": 0,
                "BW8TO15_ADR_STLY": 0,
                "BW16TO30_ADR_STLY": 0,
                "BW31TO60_ADR_STLY": 0,
                "BW61TO90_ADR_STLY": 0,
                "BW91TOUP_ADR_STLY": 0,
                "TOTAL_ADR_STLY": 0,
                "TOTAL_RMS_STLY": 0,
                "TOTAL_REV_STLY": 0,
            }));

            const totalRow = {
                "MonthName": "Total",
                "WeekNo": 0,
                "WeekName": "",
                "channel": "",
                "BW0_RMS": 0,
                "BW1_RMS": 0,
                "BW2TO7_RMS": 0,
                "BW8TO15_RMS": 0,
                "BW16TO30_RMS": 0,
                "BW31TO60_RMS": 0,
                "BW61TO90_RMS": 0,
                "BW91TOUP_RMS": 0,
                "BW0_REV": 0,
                "BW1_REV": 0,
                "BW2TO7_REV": 0,
                "BW8TO15_REV": 0,
                "BW16TO30_REV": 0,
                "BW31TO60_REV": 0,
                "BW61TO90_REV": 0,
                "BW91TOUP_REV": 0,
                "BW0_ADR": 0,
                "BW1_ADR": 0,
                "BW2TO7_ADR": 0,
                "BW8TO15_ADR": 0,
                "BW16TO30_ADR": 0,
                "BW31TO60_ADR": 0,
                "BW61TO90_ADR": 0,
                "BW91TOUP_ADR": 0,
                "TOTAL_ADR": 0,
                "TOTAL_RMS": 0,
                "TOTAL_REV": 0,

                "BW0_RMS_STLY": 0,
                "BW1_RMS_STLY": 0,
                "BW2TO7_RMS_STLY": 0,
                "BW8TO15_RMS_STLY": 0,
                "BW16TO30_RMS_STLY": 0,
                "BW31TO60_RMS_STLY": 0,
                "BW61TO90_RMS_STLY": 0,
                "BW91TOUP_RMS_STLY": 0,
                "BW0_REV_STLY": 0,
                "BW1_REV_STLY": 0,
                "BW2TO7_REV_STLY": 0,
                "BW8TO15_REV_STLY": 0,
                "BW16TO30_REV_STLY": 0,
                "BW31TO60_REV_STLY": 0,
                "BW61TO90_REV_STLY": 0,
                "BW91TOUP_REV_STLY": 0,
                "BW0_ADR_STLY": 0,
                "BW1_ADR_STLY": 0,
                "BW2TO7_ADR_STLY": 0,
                "BW8TO15_ADR_STLY": 0,
                "BW16TO30_ADR_STLY": 0,
                "BW31TO60_ADR_STLY": 0,
                "BW61TO90_ADR_STLY": 0,
                "BW91TOUP_ADR_STLY": 0,
                "TOTAL_ADR_STLY": 0,
                "TOTAL_RMS_STLY": 0,
                "TOTAL_REV_STLY": 0,
            };

            setFinalData([...monthData, totalRow]);
        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, SelectedYear, selectedMarketSegment]);

    const [CurrentYearData, setCurrentYearData] = useState([]);
    const GetCurrentYearData = async () => {

        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_WEEKLY_BOOKING_PACE,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: SelectedYear,
                        channels: selectedMarketSegment && selectedMarketSegment.length > 0 ? selectedMarketSegment : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };
    
    // Wow RNX_WoWHeatmapSingleDateSummaryModal : 
    const pickupdate = new Date(commonService.getDateInFormat(para?.asOfDate));
    const singleDateSelectedDateRef = useRef();
    const sevenMaxDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const [selectSevenDayPickupDate, setSelectSevenDayPickupDate] = useState(
        new Date(pickupdate.getTime() - 7 * 24 * 60 * 60 * 1000)
    );
    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });
    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };
    // 

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        setDataLoading(false);
    };

    const getMarketSegmentData = async () => {
        if (para?.asOfDate) {
            try {
                let chartDataResponse = await apiCall(
                    {
                        method: "POST",
                        url: API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_FILTER_ONE,
                        body: {
                            asofdate: para?.asOfDate,
                            propertycode: para?.propertyCode,
                        },
                    },
                    false
                );

                let response = apiResponse(false, chartDataResponse);
                if (response?.isValidate) {
                    let lst = [];
                    let lstSelected = [];

                    if (response?.data?.data?.combinedchannels) {
                        response?.data?.data?.combinedchannels.map((item, index) => lst.push({ label: item.combinedchannel, value: item.combinedchannel }));
                        response?.data?.data?.combinedchannels.map((item, index) => lstSelected.push(item.combinedchannel));

                    }
                    /*setSelectedMarketSegment(lstSelected)*/
                    /*setSelectedTempMarketSegment(lstSelected)*/
                    setMarketSegmentData(lst);
                }
            } catch (error) { }
        }

    };

    useEffect(() => {
        getMarketSegmentData();
    }, []);

    const handleApply = () => {
        setSelectedMarketSegment(selectedTempMarketSegment);
        multiselectRef.current.hide();
    };

    const footerTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "apply", propertyCode)}
                onClick={handleApply}
            >Apply</Button>
        </div>
    );

    useEffect(() => {
        if (!dataLoading) {
            let monthData = [];
            let LastMonthName = "";
            CurrentYearData.map((item) => {
                monthData.push({
                    "MonthName": LastMonthName === item.MonthName ? "" : item.MonthName,
                    "WeekNo": item.WeekNo,
                    "WeekName": item.WeekName,
                    "WeekStartDate": item.WeekStartDate,
                    "WeekEndDate": item.WeekEndDate,
                    "channel": item.channel,
                    "BW0_RMS": item.BW0_RMS ? parseInt(item.BW0_RMS) : 0,
                    "BW1_RMS": item.BW1_RMS ? parseInt(item.BW1_RMS) : 0,
                    "BW2TO7_RMS": item.BW2TO7_RMS ? parseInt(item.BW2TO7_RMS) : 0,
                    "BW8TO15_RMS": item.BW8TO15_RMS ? parseInt(item.BW8TO15_RMS) : 0,
                    "BW16TO30_RMS": item.BW16TO30_RMS ? parseInt(item.BW16TO30_RMS) : 0,
                    "BW31TO60_RMS": item.BW31TO60_RMS ? parseInt(item.BW31TO60_RMS) : 0,
                    "BW61TO90_RMS": item.BW61TO90_RMS ? parseInt(item.BW61TO90_RMS) : 0,
                    "BW91TOUP_RMS": item.BW91TOUP_RMS ? parseInt(item.BW91TOUP_RMS) : 0,
                    "BW0_REV": item.BW0_REV ? parseInt(item.BW0_REV) : 0,
                    "BW1_REV": item.BW1_REV ? parseInt(item.BW1_REV) : 0,
                    "BW2TO7_REV": item.BW2TO7_REV ? parseInt(item.BW2TO7_REV) : 0,
                    "BW8TO15_REV": item.BW8TO15_REV ? parseInt(item.BW8TO15_REV) : 0,
                    "BW16TO30_REV": item.BW16TO30_REV ? parseInt(item.BW16TO30_REV) : 0,
                    "BW31TO60_REV": item.BW31TO60_REV ? parseInt(item.BW31TO60_REV) : 0,
                    "BW61TO90_REV": item.BW61TO90_REV ? parseInt(item.BW61TO90_REV) : 0,
                    "BW91TOUP_REV": item.BW91TOUP_REV ? parseInt(item.BW91TOUP_REV) : 0,
                    "BW0_ADR": 0,
                    "BW1_ADR": 0,
                    "BW2TO7_ADR": 0,
                    "BW8TO15_ADR": 0,
                    "BW16TO30_ADR": 0,
                    "BW31TO60_ADR": 0,
                    "BW61TO90_ADR": 0,
                    "BW91TOUP_ADR": 0,
                    "TOTAL_ADR": 0,
                    "TOTAL_RMS": 0,
                    "TOTAL_REV": 0,

                    "BW0_RMS_STLY": item.BW0_RMS_STLY ? parseInt(item.BW0_RMS_STLY) : 0,
                    "BW1_RMS_STLY": item.BW1_RMS_STLY ? parseInt(item.BW1_RMS_STLY) : 0,
                    "BW2TO7_RMS_STLY": item.BW2TO7_RMS_STLY ? parseInt(item.BW2TO7_RMS_STLY) : 0,
                    "BW8TO15_RMS_STLY": item.BW8TO15_RMS_STLY ? parseInt(item.BW8TO15_RMS_STLY) : 0,
                    "BW16TO30_RMS_STLY": item.BW16TO30_RMS_STLY ? parseInt(item.BW16TO30_RMS_STLY) : 0,
                    "BW31TO60_RMS_STLY": item.BW31TO60_RMS_STLY ? parseInt(item.BW31TO60_RMS_STLY) : 0,
                    "BW61TO90_RMS_STLY": item.BW61TO90_RMS_STLY ? parseInt(item.BW61TO90_RMS_STLY) : 0,
                    "BW91TOUP_RMS_STLY": item.BW91TOUP_RMS_STLY ? parseInt(item.BW91TOUP_RMS_STLY) : 0,
                    "BW0_REV_STLY": item.BW0_REV_STLY ? parseInt(item.BW0_REV_STLY) : 0,
                    "BW1_REV_STLY": item.BW1_REV_STLY ? parseInt(item.BW1_REV_STLY) : 0,
                    "BW2TO7_REV_STLY": item.BW2TO7_REV_STLY ? parseInt(item.BW2TO7_REV_STLY) : 0,
                    "BW8TO15_REV_STLY": item.BW8TO15_REV_STLY ? parseInt(item.BW8TO15_REV_STLY) : 0,
                    "BW16TO30_REV_STLY": item.BW16TO30_REV_STLY ? parseInt(item.BW16TO30_REV_STLY) : 0,
                    "BW31TO60_REV_STLY": item.BW31TO60_REV_STLY ? parseInt(item.BW31TO60_REV_STLY) : 0,
                    "BW61TO90_REV_STLY": item.BW61TO90_REV_STLY ? parseInt(item.BW61TO90_REV_STLY) : 0,
                    "BW91TOUP_REV_STLY": item.BW91TOUP_REV_STLY ? parseInt(item.BW91TOUP_REV_STLY) : 0,
                    "BW0_ADR_STLY": 0,
                    "BW1_ADR_STLY": 0,
                    "BW2TO7_ADR_STLY": 0,
                    "BW8TO15_ADR_STLY": 0,
                    "BW16TO30_ADR_STLY": 0,
                    "BW31TO60_ADR_STLY": 0,
                    "BW61TO90_ADR_STLY": 0,
                    "BW91TOUP_ADR_STLY": 0,
                    "TOTAL_ADR_STLY": 0,
                    "TOTAL_RMS_STLY": 0,
                    "TOTAL_REV_STLY": 0,
                });

                LastMonthName = item.MonthName;

            });

            const totalRow = {
                "MonthName": "Total",
                "WeekNo": 0,
                "WeekName": "",
                "channel": "ALL",

                "BW0_RMS": 0,
                "BW1_RMS": 0,
                "BW2TO7_RMS": 0,
                "BW8TO15_RMS": 0,
                "BW16TO30_RMS": 0,
                "BW31TO60_RMS": 0,
                "BW61TO90_RMS": 0,
                "BW91TOUP_RMS": 0,

                "BW0_REV": 0,
                "BW1_REV": 0,
                "BW2TO7_REV": 0,
                "BW8TO15_REV": 0,
                "BW16TO30_REV": 0,
                "BW31TO60_REV": 0,
                "BW61TO90_REV": 0,
                "BW91TOUP_REV": 0,

                "BW0_ADR": 0,
                "BW1_ADR": 0,
                "BW2TO7_ADR": 0,
                "BW8TO15_ADR": 0,
                "BW16TO30_ADR": 0,
                "BW31TO60_ADR": 0,
                "BW61TO90_ADR": 0,
                "BW91TOUP_ADR": 0,

                "TOTAL_ADR": 0,
                "TOTAL_RMS": 0,
                "TOTAL_REV": 0,

                "BW0_RMS_STLY": 0,
                "BW1_RMS_STLY": 0,
                "BW2TO7_RMS_STLY": 0,
                "BW8TO15_RMS_STLY": 0,
                "BW16TO30_RMS_STLY": 0,
                "BW31TO60_RMS_STLY": 0,
                "BW61TO90_RMS_STLY": 0,
                "BW91TOUP_RMS_STLY": 0,

                "BW0_REV_STLY": 0,
                "BW1_REV_STLY": 0,
                "BW2TO7_REV_STLY": 0,
                "BW8TO15_REV_STLY": 0,
                "BW16TO30_REV_STLY": 0,
                "BW31TO60_REV_STLY": 0,
                "BW61TO90_REV_STLY": 0,
                "BW91TOUP_REV_STLY": 0,

                "BW0_ADR_STLY": 0,
                "BW1_ADR_STLY": 0,
                "BW2TO7_ADR_STLY": 0,
                "BW8TO15_ADR_STLY": 0,
                "BW16TO30_ADR_STLY": 0,
                "BW31TO60_ADR_STLY": 0,
                "BW61TO90_ADR_STLY": 0,
                "BW91TOUP_ADR_STLY": 0,

                "TOTAL_ADR_STLY": 0,
                "TOTAL_RMS_STLY": 0,
                "TOTAL_REV_STLY": 0,
            };

            monthData.map((item) => {
                item.BW0_ADR = item.BW0_REV && item.BW0_RMS ? item.BW0_REV / item.BW0_RMS : 0;
                item.BW1_ADR = item.BW1_REV && item.BW1_RMS ? item.BW1_REV / item.BW1_RMS : 0;
                item.BW2TO7_ADR = item.BW2TO7_REV && item.BW2TO7_RMS ? item.BW2TO7_REV / item.BW2TO7_RMS : 0;
                item.BW8TO15_ADR = item.BW8TO15_REV && item.BW8TO15_RMS ? item.BW8TO15_REV / item.BW8TO15_RMS : 0;
                item.BW16TO30_ADR = item.BW16TO30_REV && item.BW16TO30_RMS ? item.BW16TO30_REV / item.BW16TO30_RMS : 0;
                item.BW31TO60_ADR = item.BW31TO60_REV && item.BW31TO60_RMS ? item.BW31TO60_REV / item.BW31TO60_RMS : 0;
                item.BW61TO90_ADR = item.BW61TO90_REV && item.BW61TO90_RMS ? item.BW61TO90_REV / item.BW61TO90_RMS : 0;
                item.BW91TOUP_ADR = item.BW91TOUP_REV && item.BW91TOUP_RMS ? item.BW91TOUP_REV / item.BW91TOUP_RMS : 0;

                item.TOTAL_REV = item.BW0_REV + item.BW1_REV + item.BW2TO7_REV + item.BW8TO15_REV + item.BW16TO30_REV + item.BW31TO60_REV + item.BW61TO90_REV + item.BW91TOUP_REV;
                item.TOTAL_RMS = item.BW0_RMS + item.BW1_RMS + item.BW2TO7_RMS + item.BW8TO15_RMS + item.BW16TO30_RMS + item.BW31TO60_RMS + item.BW61TO90_RMS + item.BW91TOUP_RMS;
                item.TOTAL_ADR = item.TOTAL_REV && item.TOTAL_RMS ? item.TOTAL_REV / item.TOTAL_RMS : 0;

                totalRow.BW0_RMS += item.BW0_RMS;
                totalRow.BW1_RMS += item.BW1_RMS;
                totalRow.BW2TO7_RMS += item.BW2TO7_RMS;
                totalRow.BW8TO15_RMS += item.BW8TO15_RMS;
                totalRow.BW16TO30_RMS += item.BW16TO30_RMS;
                totalRow.BW31TO60_RMS += item.BW31TO60_RMS;
                totalRow.BW61TO90_RMS += item.BW61TO90_RMS;
                totalRow.BW91TOUP_RMS += item.BW91TOUP_RMS;
                totalRow.TOTAL_RMS += item.TOTAL_RMS;

                totalRow.BW0_REV += item.BW0_REV;
                totalRow.BW1_REV += item.BW1_REV;
                totalRow.BW2TO7_REV += item.BW2TO7_REV;
                totalRow.BW8TO15_REV += item.BW8TO15_REV;
                totalRow.BW16TO30_REV += item.BW16TO30_REV;
                totalRow.BW31TO60_REV += item.BW31TO60_REV;
                totalRow.BW61TO90_REV += item.BW61TO90_REV;
                totalRow.BW91TOUP_REV += item.BW91TOUP_REV;
                totalRow.TOTAL_REV += item.TOTAL_REV;


                totalRow.BW0_ADR = totalRow.BW0_RMS && totalRow.BW0_REV ? totalRow.BW0_REV / totalRow.BW0_RMS : 0;
                totalRow.BW1_ADR = totalRow.BW1_RMS && totalRow.BW1_REV ? totalRow.BW1_REV / totalRow.BW1_RMS : 0;
                totalRow.BW2TO7_ADR = totalRow.BW2TO7_RMS && totalRow.BW2TO7_REV ? totalRow.BW2TO7_REV / totalRow.BW2TO7_RMS : 0;
                totalRow.BW8TO15_ADR = totalRow.BW8TO15_RMS && totalRow.BW8TO15_REV ? totalRow.BW8TO15_REV / totalRow.BW8TO15_RMS : 0;
                totalRow.BW16TO30_ADR = totalRow.BW16TO30_RMS && totalRow.BW16TO30_REV ? totalRow.BW16TO30_REV / totalRow.BW16TO30_RMS : 0;
                totalRow.BW31TO60_ADR = totalRow.BW31TO60_RMS && totalRow.BW31TO60_REV ? totalRow.BW31TO60_REV / totalRow.BW31TO60_RMS : 0;
                totalRow.BW61TO90_ADR = totalRow.BW61TO90_RMS && totalRow.BW61TO90_REV ? totalRow.BW61TO90_REV / totalRow.BW61TO90_RMS : 0;
                totalRow.BW91TOUP_ADR = totalRow.BW91TOUP_RMS && totalRow.BW91TOUP_REV ? totalRow.BW91TOUP_REV / totalRow.BW91TOUP_RMS : 0;
                totalRow.TOTAL_ADR = totalRow.TOTAL_REV && totalRow.TOTAL_RMS ? totalRow.TOTAL_REV / totalRow.TOTAL_RMS : 0;





                item.BW0_ADR_STLY = item.BW0_REV_STLY && item.BW0_RMS_STLY ? item.BW0_REV_STLY / item.BW0_RMS_STLY : 0;
                item.BW1_ADR_STLY = item.BW1_REV_STLY && item.BW1_RMS_STLY ? item.BW1_REV_STLY / item.BW1_RMS_STLY : 0;
                item.BW2TO7_ADR_STLY = item.BW2TO7_REV_STLY && item.BW2TO7_RMS_STLY ? item.BW2TO7_REV_STLY / item.BW2TO7_RMS_STLY : 0;
                item.BW8TO15_ADR_STLY = item.BW8TO15_REV_STLY && item.BW8TO15_RMS_STLY ? item.BW8TO15_REV_STLY / item.BW8TO15_RMS_STLY : 0;
                item.BW16TO30_ADR_STLY = item.BW16TO30_REV_STLY && item.BW16TO30_RMS_STLY ? item.BW16TO30_REV_STLY / item.BW16TO30_RMS_STLY : 0;
                item.BW31TO60_ADR_STLY = item.BW31TO60_REV_STLY && item.BW31TO60_RMS_STLY ? item.BW31TO60_REV_STLY / item.BW31TO60_RMS_STLY : 0;
                item.BW61TO90_ADR_STLY = item.BW61TO90_REV_STLY && item.BW61TO90_RMS_STLY ? item.BW61TO90_REV_STLY / item.BW61TO90_RMS_STLY : 0;
                item.BW91TOUP_ADR_STLY = item.BW91TOUP_REV_STLY && item.BW91TOUP_RMS_STLY ? item.BW91TOUP_REV_STLY / item.BW91TOUP_RMS_STLY : 0;

                item.TOTAL_REV_STLY = item.BW0_REV_STLY + item.BW1_REV_STLY + item.BW2TO7_REV_STLY + item.BW8TO15_REV_STLY + item.BW16TO30_REV_STLY + item.BW31TO60_REV_STLY + item.BW61TO90_REV_STLY + item.BW91TOUP_REV_STLY;
                item.TOTAL_RMS_STLY = item.BW0_RMS_STLY + item.BW1_RMS_STLY + item.BW2TO7_RMS_STLY + item.BW8TO15_RMS_STLY + item.BW16TO30_RMS_STLY + item.BW31TO60_RMS_STLY + item.BW61TO90_RMS_STLY + item.BW91TOUP_RMS_STLY;
                item.TOTAL_ADR_STLY = item.TOTAL_REV_STLY && item.TOTAL_RMS_STLY ? item.TOTAL_REV_STLY / item.TOTAL_RMS_STLY : 0;

                totalRow.BW0_RMS_STLY += item.BW0_RMS_STLY;
                totalRow.BW1_RMS_STLY += item.BW1_RMS_STLY;
                totalRow.BW2TO7_RMS_STLY += item.BW2TO7_RMS_STLY;
                totalRow.BW8TO15_RMS_STLY += item.BW8TO15_RMS_STLY;
                totalRow.BW16TO30_RMS_STLY += item.BW16TO30_RMS_STLY;
                totalRow.BW31TO60_RMS_STLY += item.BW31TO60_RMS_STLY;
                totalRow.BW61TO90_RMS_STLY += item.BW61TO90_RMS_STLY;
                totalRow.BW91TOUP_RMS_STLY += item.BW91TOUP_RMS_STLY;
                totalRow.TOTAL_RMS_STLY += item.TOTAL_RMS_STLY;

                totalRow.BW0_REV_STLY += item.BW0_REV_STLY;
                totalRow.BW1_REV_STLY += item.BW1_REV_STLY;
                totalRow.BW2TO7_REV_STLY += item.BW2TO7_REV_STLY;
                totalRow.BW8TO15_REV_STLY += item.BW8TO15_REV_STLY;
                totalRow.BW16TO30_REV_STLY += item.BW16TO30_REV_STLY;
                totalRow.BW31TO60_REV_STLY += item.BW31TO60_REV_STLY;
                totalRow.BW61TO90_REV_STLY += item.BW61TO90_REV_STLY;
                totalRow.BW91TOUP_REV_STLY += item.BW91TOUP_REV_STLY;
                totalRow.TOTAL_REV_STLY += item.TOTAL_REV_STLY;


                totalRow.BW0_ADR_STLY = totalRow.BW0_RMS_STLY && totalRow.BW0_REV_STLY ? totalRow.BW0_REV_STLY / totalRow.BW0_RMS_STLY : 0;
                totalRow.BW1_ADR_STLY = totalRow.BW1_RMS_STLY && totalRow.BW1_REV_STLY ? totalRow.BW1_REV_STLY / totalRow.BW1_RMS_STLY : 0;
                totalRow.BW2TO7_ADR_STLY = totalRow.BW2TO7_RMS_STLY && totalRow.BW2TO7_REV_STLY ? totalRow.BW2TO7_REV_STLY / totalRow.BW2TO7_RMS_STLY : 0;
                totalRow.BW8TO15_ADR_STLY = totalRow.BW8TO15_RMS_STLY && totalRow.BW8TO15_REV_STLY ? totalRow.BW8TO15_REV_STLY / totalRow.BW8TO15_RMS_STLY : 0;
                totalRow.BW16TO30_ADR_STLY = totalRow.BW16TO30_RMS_STLY && totalRow.BW16TO30_REV_STLY ? totalRow.BW16TO30_REV_STLY / totalRow.BW16TO30_RMS_STLY : 0;
                totalRow.BW31TO60_ADR_STLY = totalRow.BW31TO60_RMS_STLY && totalRow.BW31TO60_REV_STLY ? totalRow.BW31TO60_REV_STLY / totalRow.BW31TO60_RMS_STLY : 0;
                totalRow.BW61TO90_ADR_STLY = totalRow.BW61TO90_RMS_STLY && totalRow.BW61TO90_REV_STLY ? totalRow.BW61TO90_REV_STLY / totalRow.BW61TO90_RMS_STLY : 0;
                totalRow.BW91TOUP_ADR_STLY = totalRow.BW91TOUP_RMS_STLY && totalRow.BW91TOUP_REV_STLY ? totalRow.BW91TOUP_REV_STLY / totalRow.BW91TOUP_RMS_STLY : 0;
                totalRow.TOTAL_ADR_STLY = totalRow.TOTAL_REV_STLY && totalRow.TOTAL_RMS_STLY ? totalRow.TOTAL_REV_STLY / totalRow.TOTAL_RMS_STLY : 0;

            });



            setFinalData([...monthData, totalRow]);

        }
    }, [dataLoading]);

    const MinOpacity = 0.3;

    const RMSRGP = "rgba(132, 210, 246, DIFF)";

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .TOTAL_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW0_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW1_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW2TO7_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW8TO15_RMS`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW16TO30_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW31TO60_RMS`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW61TO90_RMS`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        RMSRGP,
        `#${tblids.id1} .BW91TOUP_RMS`,
        MinOpacity
    );


    const ADRRGP = "rgba(255, 200, 138, DIFF)";

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .TOTAL_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW0_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW1_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW2TO7_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW8TO15_ADR`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW16TO30_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW31TO60_ADR`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW61TO90_ADR`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        ADRRGP,
        `#${tblids.id1} .BW91TOUP_ADR`,
        MinOpacity
    );

    const REVRGP = "rgba(145, 197, 145, DIFF)";

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .TOTAL_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW0_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW1_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW2TO7_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW8TO15_REV`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW16TO30_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW31TO60_REV`,
        MinOpacity
    );


    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW61TO90_REV`,
        MinOpacity
    );

    commonService.setBackColorWithCompareSameTDIndex(
        REVRGP,
        `#${tblids.id1} .BW91TOUP_REV`,
        MinOpacity
    );






    /*FixColumn(tblids.id1, [1, 2]);*/

    return (

        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "RNX STOM Pickup",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.RNXAnalysis1,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "downloadIcon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.rnxtbl1}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.rnxtbl1,
                                    `${para?.propertyCode}-RNX STOM Pickup-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable mainTableClass">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table id={tblids.id1} className="table-with-spacing positionStaticTable dailySummaryTbl">
                            <thead className="tbl-header-sticky">
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th colSpan="5" >
                                        <MultiSelect id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "month", propertyCode)}
                                            ref={multiselectRef}
                                            filter
                                            placeholder="Select Channels"
                                            display="values"
                                            selectedItemsLabel="{0} channels selected"
                                            maxSelectedLabels={0}
                                            closeOnSelect={false}
                                            value={selectedTempMarketSegment}
                                            options={marketSegmentData}
                                            onChange={(e) => {
                                                setSelectedTempMarketSegment(e.value);
                                            }}
                                            panelFooterTemplate={footerTemplate}
                                        />
                                    </th>

                                    <th colSpan="56" className={"text-center"}>WEEKLY BOOKING WINDOW</th>
                                </tr>
                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th colSpan="2">
                                        <div>
                                            <Form.Select id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "month", propertyCode)}
                                                value={SelectedYear}
                                                onChange={(e) => {
                                                    setSelectedYear(e.target.value);
                                                }}
                                                style={{ padding: 0 }}
                                            >
                                                <option value="">Select</option>
                                                {yearsArr?.map((item, index) => (
                                                    <option key={index} value={item}>
                                                        {item}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <span style={{ display: "none" }}>
                                                {SelectedYear}
                                            </span>
                                        </div>
                                    </th>

                                    <th className={"border-right text-center"} colSpan="6">Total</th>
                                    <th className={"border-right text-center"} colSpan="6">0 Day</th>
                                    <th className={"border-right text-center"} colSpan="6">1 Day</th>
                                    <th className={"border-right text-center"} colSpan="6">2 To 7 Days</th>
                                    <th className={"border-right text-center"} colSpan="6">8 To 15 Days</th>
                                    <th className={"border-right text-center"} colSpan="6">16 To 30 Days</th>
                                    <th className={"border-right text-center"} colSpan="6">31 To 60 Days</th>
                                    <th className={"border-right text-center"} colSpan="6">61 To 90 Days</th>
                                    <th className={"border-right text-center"} colSpan="6">90+ Days</th>

                                </tr>

                                <tr className="diff-bg-tr table-main-header-tr">
                                    <th>Month</th>
                                    <th>Week</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>

                                    <th className={"border-right"}>RMS</th>
                                    <th>STLY</th>
                                    <th className={"text-end"}>ADR</th>
                                    <th className={"text-end"}>STLY</th>
                                    <th className={"text-end"}>REV</th>
                                    <th className={"text-end"}>STLY</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataLoading ?
                                        <tr
                                            style={{
                                                height: "80px",
                                                position: "relative",
                                            }}
                                        >
                                            <Loader />
                                        </tr>
                                        :
                                        <>
                                            {FinalData?.map((item, index) => (
                                                <tr>
                                                    <td className={` ${item.MonthName === "Total" ? "boldTd" : ""}`}>{item.MonthName}</td>
                                                    <td className={` ${item.MonthName === "Total" ? "boldTd" : ""}`}>{item.WeekName}</td>

                                                    <td id={commonService.generateGlobalClickTrackerID("RNXWOWPickup", "total-rms", item)} className={`border-right cursor-pointer  ${item.MonthName === "Total" ? "boldTd" : "TOTAL_RMS"}`} value={item.TOTAL_RMS} 
                                                    onClick={(e)=>{
                                                        singleDateSelectedDateRef.current = {WeekStartDate:item.WeekStartDate, WeekEndDate:item.WeekEndDate};
                                                        handleFilterBtnClick(e)
                                                        selectedTdIndexRef.current = index;                 
                                                    }}>
                                                    {item.TOTAL_RMS}
                                                    </td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "TOTAL_RMS_STLY"}`} value={item.TOTAL_RMS_STLY}>{item.TOTAL_RMS_STLY}</td>

                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "TOTAL_ADR"}`} value={item.TOTAL_ADR}>{commonService.formateAmount(item.TOTAL_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "TOTAL_ADR_STLY"}`} value={item.TOTAL_ADR_STLY}>{commonService.formateAmount(item.TOTAL_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "TOTAL_REV"}`} value={item.TOTAL_REV}>{commonService.formateAmount(item.TOTAL_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "TOTAL_REV_STLY"}`} value={item.TOTAL_REV_STLY}>{commonService.formateAmount(item.TOTAL_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW0_RMS"}`} value={item.BW0_RMS}>{item.BW0_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW0_RMS_STLY"}`} value={item.BW0_RMS_STLY}>{item.BW0_RMS_STLY}</td>

                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW0_ADR"}`} value={item.BW0_ADR}>{commonService.formateAmount(item.BW0_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW0_ADR_STLY"}`} value={item.BW0_ADR_STLY}>{commonService.formateAmount(item.BW0_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW0_REV"}`} value={item.BW0_REV}>{commonService.formateAmount(item.BW0_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW0_REV_STLY"}`} value={item.BW0_REV_STLY}>{commonService.formateAmount(item.BW0_REV_STLY)}</td>


                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW1_RMS"}`} value={item.BW1_RMS}>{item.BW1_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW1_RMS_STLY"}`} value={item.BW1_RMS_STLY}>{item.BW1_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW1_ADR"}`} value={item.BW1_ADR}>{commonService.formateAmount(item.BW1_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW1_ADR_STLY"}`} value={item.BW1_ADR_STLY}>{commonService.formateAmount(item.BW1_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW1_REV"}`} value={item.BW1_REV}>{commonService.formateAmount(item.BW1_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW1_REV_STLY"}`} value={item.BW1_REV_STLY}>{commonService.formateAmount(item.BW1_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW2TO7_RMS"}`} value={item.BW2TO7_RMS}>{item.BW2TO7_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW2TO7_RMS_STLY"}`} value={item.BW2TO7_RMS_STLY}>{item.BW2TO7_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW2TO7_ADR"}`} value={item.BW2TO7_ADR}>{commonService.formateAmount(item.BW2TO7_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW2TO7_ADR_STLY"}`} value={item.BW2TO7_ADR_STLY}>{commonService.formateAmount(item.BW2TO7_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW2TO7_REV"}`} value={item.BW2TO7_REV}>{commonService.formateAmount(item.BW2TO7_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW2TO7_REV_STLY"}`} value={item.BW2TO7_REV_STLY}>{commonService.formateAmount(item.BW2TO7_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW8TO15_RMS"}`} value={item.BW8TO15_RMS}>{item.BW8TO15_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW8TO15_RMS_STLY"}`} value={item.BW8TO15_RMS_STLY}>{item.BW8TO15_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW8TO15_ADR"}`} value={item.BW8TO15_ADR}>{commonService.formateAmount(item.BW8TO15_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW8TO15_ADR_STLY"}`} value={item.BW8TO15_ADR_STLY}>{commonService.formateAmount(item.BW8TO15_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW8TO15_REV"}`} value={item.BW8TO15_REV}>{commonService.formateAmount(item.BW8TO15_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW8TO15_REV_STLY"}`} value={item.BW8TO15_REV_STLY}>{commonService.formateAmount(item.BW8TO15_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW16TO30_RMS"}`} value={item.BW16TO30_RMS}>{item.BW16TO30_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW16TO30_RMS_STLY"}`} value={item.BW16TO30_RMS_STLY}>{item.BW16TO30_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW16TO30_ADR"}`} value={item.BW16TO30_ADR}>{commonService.formateAmount(item.BW16TO30_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW16TO30_ADR_STLY"}`} value={item.BW16TO30_ADR_STLY}>{commonService.formateAmount(item.BW16TO30_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW16TO30_REV"}`} value={item.BW16TO30_REV}>{commonService.formateAmount(item.BW16TO30_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW16TO30_REV_STLY"}`} value={item.BW16TO30_REV_STLY}>{commonService.formateAmount(item.BW16TO30_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW31TO60_RMS"}`} value={item.BW31TO60_RMS}>{item.BW31TO60_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW31TO60_RMS_STLY"}`} value={item.BW31TO60_RMS_STLY}>{item.BW31TO60_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW31TO60_ADR"}`} value={item.BW31TO60_ADR}>{commonService.formateAmount(item.BW31TO60_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW31TO60_ADR_STLY"}`} value={item.BW31TO60_ADR_STLY}>{commonService.formateAmount(item.BW31TO60_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW31TO60_REV"}`} value={item.BW31TO60_REV}>{commonService.formateAmount(item.BW31TO60_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW31TO60_REV_STLY"}`} value={item.BW31TO60_REV_STLY}>{commonService.formateAmount(item.BW31TO60_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW61TO90_RMS"}`} value={item.BW61TO90_RMS}>{item.BW61TO90_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW61TO90_RMS_STLY"}`} value={item.BW61TO90_RMS_STLY}>{item.BW61TO90_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW61TO90_ADR"}`} value={item.BW61TO90_ADR}>{commonService.formateAmount(item.BW61TO90_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW61TO90_ADR_STLY"}`} value={item.BW61TO90_ADR_STLY}>{commonService.formateAmount(item.BW61TO90_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW61TO90_REV"}`} value={item.BW61TO90_REV}>{commonService.formateAmount(item.BW61TO90_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW61TO90_REV_STLY"}`} value={item.BW61TO90_REV_STLY}>{commonService.formateAmount(item.BW61TO90_REV_STLY)}</td>

                                                    <td className={`border-right  ${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_RMS"}`} value={item.BW91TOUP_RMS}>{item.BW91TOUP_RMS}</td>
                                                    <td className={`${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_RMS_STLY"}`} value={item.BW91TOUP_RMS_STLY}>{item.BW91TOUP_RMS_STLY}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_ADR"}`} value={item.BW91TOUP_ADR}>{commonService.formateAmount(item.BW91TOUP_ADR)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_ADR_STLY"}`} value={item.BW91TOUP_ADR_STLY}>{commonService.formateAmount(item.BW91TOUP_ADR_STLY)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_REV"}`} value={item.BW91TOUP_REV}>{commonService.formateAmount(item.BW91TOUP_REV)}</td>
                                                    <td className={`text-end  ${item.MonthName === "Total" ? "boldTd" : "BW91TOUP_REV_STLY"}`} value={item.BW91TOUP_REV_STLY}>{commonService.formateAmount(item.BW91TOUP_REV_STLY)}</td>
                                                </tr>
                                            ))}
                                        </>
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}

            {
                widgetModal && (
                    <WidgetDetailModal
                        showModal={widgetModal}
                        closeModal={closeWidgetModal}
                        data={widgetDetailRef.current}
                    />
                )
            }

            <Overlay
                  show={ONTHEBOOKS.IsDisplay}
                  target={ONTHEBOOKS.Target}
                  placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 11 }}
                >
                    <div className="horizontal-menu-option active">
                        <RNX_WoWHeatmapSingleWeekSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={
                                selectSevenDayPickupDate
                                    ? selectSevenDayPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                        />
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};
export default RNXWOWPickup;

